import React from 'react';
import { Button } from 'antd';

export default class ConfirmDeleteButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.onDelete = this.props.onDelete || (() => {});
    this.onConfirm = this.props.onConfirm || (() => {});
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isConfirm !== undefined) {
      return { confirm: props.isConfirm === true };
    }
    return null;
  }

  render() {
    return this.state.confirm ? (
      <Button
        {...this.props.buttonProps}
        type={'danger'}
        disabled={this.props.disabled}
        style={this.props.buttonStyle}
        onClick={async e => {
          e.preventDefault();
          e.stopPropagation();
          try {
            return await this.onDelete();
          } catch (err) {
            this.setState({ confirm: false });
          }
        }}
      >
        {this.props.confirmLabel || 'Confirm!'}
      </Button>
    ) : (
      <Button
        {...this.props.buttonProps}
        disabled={this.props.disabled}
        type={'danger'}
        ghost
        style={this.props.buttonStyle}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          this.setState({ confirm: true });
          return this.onConfirm();
        }}
      >
        {this.props.deleteLabel || 'Delete'}
      </Button>
    );
  }
}
